import { apiBaseURL, assetType, toastTypes } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { metaDataAction } from "../metaDataAction";


export const fetchAssetAction = (filter) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.get(apiBaseURL.ASSET + '?page=' + filter?.page + '&perPage=' + filter?.perPage+'&sortCountry='+filter?.sortCountry+'&search='+filter?.search);
        dispatch({ type: assetType.ADD_ASSET, payload: response.data.data });
        dispatch(metaDataAction({pageSize:filter?.perPage,totalPages:response.data.data.totalPage,totalItems:response.data.data.totalRecords}))
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastTypes.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    }
};

export const assetAddAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.post(apiBaseURL.ASSET, data);
        dispatch(fetchAssetAction({page:1,perPage:10}))
        // dispatch({ type: assetType.ADD_ASSET, payload: response.data.data });
        // dispatch(metaDataAction({pageSize:filter?.perPage,totalPages:response.data.data.totalPage,totalItems:response.data.data.totalRecords}))
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastTypes.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    }
};



